// Todos os textos da página /conheca num só lugar.
// Regra: não inventar números, depoimentos, paróquias, garantias nem porcentagens.
// Preço/taxa: usar exatamente o texto que já existia na página (não criar valores).

export const WHATSAPP_URL =
  'https://wa.me/5514996402835?text=Ol%C3%A1!%20Quero%20organizar%20um%20evento%20no%20Se%20Liga.';

export const INSTAGRAM_URL = 'https://www.instagram.com/seliga.catolico';

export const SEO = {
  titulo: 'Para organizadores — Se Liga',
  descricao:
    'Divulgue seu evento e venda pelo celular: inscrições, ingressos, fichas, ação entre amigos, portaria, caixa e relatório de fechamento num app só.',
};

// Abertura curta da página.
export const ABERTURA = {
  titulo: 'Divulgue seu evento e venda pelo celular',
  linha: 'Inscrições, ingressos, fichas, ação entre amigos, portaria, caixa e relatório.',
  botaoPrimario: 'Criar meu evento',
  botaoWhatsapp: 'Falar no WhatsApp',
};

// Como funciona — 4 passos. (Os mesmos passos aparecem na home.)
export const COMO_FUNCIONA = {
  titulo: 'Em quatro passos',
  passos: [
    {
      numero: '1',
      titulo: 'Crie o evento',
      texto: 'Nome, datas, local e capa. Salva sozinho enquanto você digita.',
    },
    {
      numero: '2',
      titulo: 'Escolha como vender',
      texto: 'Ingresso, inscrição, fichas ou ação entre amigos. Você define os valores.',
    },
    {
      numero: '3',
      titulo: 'Divulgue o link e o QR',
      texto: 'Sua página fica no ar. Compartilhe no grupo e imprima o QR.',
    },
    {
      numero: '4',
      titulo: 'Acompanhe no painel',
      texto: 'Vendas, portaria, caixa e relatório de fechamento, do celular.',
    },
  ],
  link: 'Ver como funciona',
};

// Tudo num app só — grade de cartõezinhos.
export interface ItemApp {
  icone: string;
  titulo: string;
  texto: string;
}

export const TUDO_NO_APP = {
  titulo: 'Tudo num app só',
  itens: [
    {
      icone: 'ri-file-list-3-line',
      titulo: 'Inscrições e ingressos',
      texto: 'Venda e receba pelo Pix, com QR no celular.',
    },
    {
      icone: 'ri-restaurant-2-line',
      titulo: 'Fichas e barracas',
      texto: 'Quermesse sem ficha de papel.',
    },
    {
      icone: 'ri-hand-heart-line',
      titulo: 'Ação entre amigos',
      texto: 'Talões por vendedor e número garantido.',
    },
    {
      icone: 'ri-qr-scan-2-line',
      titulo: 'Portaria com QR',
      texto: 'Leia o ingresso na entrada pelo celular.',
    },
    {
      icone: 'ri-money-dollar-circle-line',
      titulo: 'Caixa e sangria',
      texto: 'Cada operador usa o próprio celular.',
    },
    {
      icone: 'ri-team-line',
      titulo: 'Equipe por função',
      texto: 'Caixa, barraca e portaria por link.',
    },
    {
      icone: 'ri-notification-3-line',
      titulo: 'Avisos no celular',
      texto: 'A equipe recebe o recado na hora.',
    },
    {
      icone: 'ri-file-chart-line',
      titulo: 'Relatório de fechamento',
      texto: 'Vendido, taxas e líquido numa tela.',
    },
  ] as ItemApp[],
};

// Quanto custa — texto exato que já existia na página (não mudar valores).
export const QUANTO_CUSTA = {
  titulo: 'Quanto custa',
  texto:
    'Divulgar um evento é gratuito. Quando há cobrança (ingresso, inscrição paga, fichas ou ação entre amigos), existe uma taxa de serviço combinada com o organizador e mostrada na tela antes de publicar. Fale com a gente para saber a condição do seu evento.',
};

// Perguntas frequentes — reaproveitadas das já existentes.
export const PERGUNTAS = {
  titulo: 'Perguntas frequentes',
  itens: [
    {
      pergunta: 'A pessoa precisa criar conta para comprar?',
      resposta:
        'Para ingressos e fichas, não: ela compra com nome e WhatsApp e recebe no celular. Para se inscrever num acampamento (que tem ficha), sim, porque a ficha fica guardada para os próximos eventos.',
    },
    {
      pergunta: 'Como o dinheiro chega até nós?',
      resposta:
        'De dois jeitos: direto na conta Mercado Pago da sua paróquia ou grupo (a plataforma só retém a taxa), ou na conta do Se Liga, com repasse por Pix para a chave que você cadastrar. Você escolhe ao criar o evento.',
    },
    {
      pergunta: 'Funciona no celular?',
      resposta:
        'Sim, foi feito para o celular. Dá para colocar na tela inicial como um app, sem loja de aplicativos.',
    },
    {
      pergunta: 'Os dados das fichas ficam seguros?',
      resposta:
        'Cada organizador só vê o próprio evento; fotos e documentos ficam em área privada; a plataforma tem política de privacidade e termos publicados, e a pessoa pode pedir a exclusão da conta.',
    },
    {
      pergunta: 'Como falo com vocês?',
      resposta:
        'Pelo WhatsApp (botão no fim da página). Acompanhamos de perto os primeiros eventos de cada organizador.',
    },
  ],
};

// Legendas usadas pelas molduras de celular (home).
export const MOCKUPS = {
  titulo: 'Do jeito que a pessoa vê no celular',
  legendaEvento: 'Página do evento',
  legendaIngresso: 'Ingresso com QR',
  legendaPainel: 'Painel · Financeiro',
};